import { measuredUsingConfigFor as wrap } from '../Core/Helpers/configHelpers';

const getMeasuredUsingConfig = (prefix: string) => {
  const balance = wrap(`${prefix}.Preparation.Balance`);
  return {
    [`${prefix}.Preparation.TareMass`]: balance,
    [`${prefix}.Preparation.TareAndSampleMass`]: balance,
    [`${prefix}.Preparation.PreparedSampleMass`]: balance,
  };
};

export default getMeasuredUsingConfig;
